'use client';

import type { BoxProps } from '@mui/material/Box';

import { forwardRef } from 'react';

import Box from '@mui/material/Box';

import { logoClasses } from './classes';

export const GradientBg = forwardRef<HTMLDivElement, BoxProps>(
  ({ width, height, className, sx, ...other }, ref) => {
    const bg = (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="198"
        height="146"
        viewBox="0 0 198 146"
        fill="none"
      >
        <g opacity="0.3" filter="url(#filter0_f_8336_36933)">
          <path
            d="M190.945 27.356H6.94531V118.356H190.945V27.356Z"
            fill="url(#paint0_linear_8336_36933)"
            fillOpacity="0.8"
          />
        </g>
        <defs>
          <filter
            id="filter0_f_8336_36933"
            x="-43.0547"
            y="-22.644"
            width="284"
            height="191"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="25" result="effect1_foregroundBlur_8336_36933" />
          </filter>
          <linearGradient
            id="paint0_linear_8336_36933"
            x1="6.94531"
            y1="40.4109"
            x2="109.033"
            y2="-50.832"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#45A3F9" />
            <stop offset="0.375" stopColor="#8920FE" stopOpacity="0.81" />
            <stop offset="0.619792" stopColor="#FF0BE5" />
            <stop offset="1" stopColor="#FFC800" />
          </linearGradient>
        </defs>
      </svg>
    );

    return (
      <Box
        ref={ref}
        className={logoClasses.root.concat(className ? ` ${className}` : '')}
        sx={{
          ...sx,
        }}
        {...other}
      >
        {bg}
      </Box>
    );
  }
);
